import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiEndpoints } from "../../services/apiConfig";



export const fetchCompanies = createAsyncThunk(
  "database/fetchCompanies",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        apiEndpoints.getDatabaseCompanies,
        payload,
        {
          timeout: 1000 * 60 * 5, // ⏳ 5 minutes (in ms)
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


// 🔹 Async thunk: Fetch People
export const fetchPeople = createAsyncThunk(
  "database/fetchPeople",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        apiEndpoints.getDatabasePeopleSearch,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchIpData = createAsyncThunk(
  "database/fetchIpData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(apiEndpoints.fetchIpInfo);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchPromptSuggestions = createAsyncThunk(
  "suggestions/fetchPromptSuggestions",
  async (searchTerm, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${apiEndpoints.getPromptSuggestions}?q=${encodeURIComponent(searchTerm)}`,
        {
          timeout: 10000, // 10 seconds timeout
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 🔹 Slice
const databaseSlice = createSlice({
  name: "database",
  initialState: {
    companies: [],
    people: [],
    suggestions: [],
    suggestionsLoading: false,
    ipData: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearDatabaseState: (state) => {
      state.companies = [];
      state.people = [];
      state.error = null;
      state.ipData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ✅ Companies
      .addCase(fetchCompanies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.loading = false;
        state.companies = action.payload?.data || [];
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // ✅ People
      .addCase(fetchPeople.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPeople.fulfilled, (state, action) => {
        state.loading = false;
        state.people = action.payload?.data || [];
      })
      .addCase(fetchPeople.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchIpData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIpData.fulfilled, (state, action) => {
        state.loading = false;
        state.ipData = action.payload || null;
      })
      .addCase(fetchIpData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchPromptSuggestions.pending, (state) => {
        state.suggestionsLoading = true;
        state.error = null;
      })
      .addCase(fetchPromptSuggestions.fulfilled, (state, action) => {
        state.suggestionsLoading = false;
        // Adjust based on your API response structure
        // If API returns { suggestions: [...] }
        state.suggestions = action.payload?.suggestions || action.payload || [];
      })
      .addCase(fetchPromptSuggestions.rejected, (state, action) => {
        state.suggestionsLoading = false;
        state.error = action.payload;
        state.suggestions = [];
      });
  },
});

export const { clearDatabaseState } = databaseSlice.actions;
export default databaseSlice.reducer;
